import { render } from "./FloatingNav.vue?vue&type=template&id=70674661&scoped=true"
import script from "./FloatingNav.vue?vue&type=script&lang=js"
export * from "./FloatingNav.vue?vue&type=script&lang=js"

import "./FloatingNav.vue?vue&type=style&index=0&id=70674661&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70674661"]])

export default __exports__